'use client'

import { cn } from '@/lib/utils'
import { UsePromptFormReturn } from '@/lib/types'
import { PromptAreaTextarea } from '@/components/prompt-area/prompt-area-textarea'
import { AnimatedButton } from '@/components/ui/animated-button'
import { PromptAreaImageInline } from '@/components/prompt-area/prompt-area-image-inline'
import { ModelSelectorContainer } from './model-selector'

export function PromptAreaImage({
    promptForm,
    requestInProgress
}: {
    promptForm: UsePromptFormReturn
    requestInProgress: boolean
}) {
    return (
        <div className="flex w-full gap-3">
            <div className={cn(
                'flex flex-col gap-2 w-full relative border border-border rounded-lg p-2 bg-background8 transition-all duration-200 ease-in-out',
                promptForm.isDragActive && 'ring-0 ring-primary ring-offset-0 bg-primary/5',
                promptForm.isTextAreaFocused && 'border-ring border'
            )}>
                <div className="flex items-start gap-2">
                    <div className="flex-1">
                        <PromptAreaTextarea promptForm={promptForm} />
                    </div>
                    {promptForm.currentSubMode?.label === 'Edit' && <div className="w-[60px] h-[60px] flex-shrink-0">
                        <PromptAreaImageInline promptForm={promptForm} />
                    </div>}
                </div>
                <div className="flex flex-row items-center justify-end">
                    {/* <ModelSelectorContainer
                        model={promptForm.formValues.model}
                        onModelChange={promptForm.handleModelChange}
                        modelType={'image'}
                    /> */}
                    <AnimatedButton
                        lottieIcon="send"
                        type="submit"
                        size="icon"
                        animationTrigger='motion-complete'
                        className="h-8 w-8 bg-primary flex items-center justify-center"
                        disabled={promptForm.isUploading || requestInProgress}
                    />
                </div>
            </div>
        </div>
    )
}


